import { tns } from "tiny-slider";

export const cardsSlider = () => {
    const sliderWrappers = document.getElementsByClassName('cards-slider-wrapper');

    Array.from(sliderWrappers).forEach(sliderWrapper => {
        const sliderContainer = sliderWrapper.getElementsByClassName('cards-slider')[0];
        const slides = sliderContainer.getElementsByClassName('slide');

        function getSliderOptions() {
            return {
                container: sliderWrapper.getElementsByClassName('cards-slider')[0],
                startIndex: 0,
                autoplay: false,
                loop: true,
                swipeAngle: false,
                nav: false,
                fixedWidth: 280,
                gutter: 16,
                items: 4,
                speed: 400,
                lazyload: true,
                slideBy: 2,
                lazyloadSelector: '.lazy',
                controlsContainer: sliderWrapper.getElementsByClassName('slider-controls')[0],
                controls: () => {
                    sliderContainer.offsetWidth
                },
            }
        }

        let slider = null;

        if (slides.length > 4) {
            sliderWrapper.getElementsByClassName('slider-controls')[0].classList.remove('hidden');
            slider = tns(getSliderOptions());
        } else {
            const mediaQuery = window.matchMedia('(max-width: 1199px)');

            function handleMediaQueryChange(event) {
                if (event.matches) {
                    sliderWrapper.getElementsByClassName('slider-controls')[0].classList.remove('hidden');
                    slider = tns(getSliderOptions());
                } else {
                    if (slider) slider.destroy();
                    sliderWrapper.getElementsByClassName('slider-controls')[0].classList.add('hidden');
                }
            }

            handleMediaQueryChange(mediaQuery);
            mediaQuery.addEventListener('change', handleMediaQueryChange);
        }
    });
}
